import React, { useMemo, useReducer } from "react";
import { useState } from "react";
import { useRef } from "react";
import OptionsManagement from "../../FieldComponents/OptionsManagement";

//optionChoices
export const useOptionChoices = () => {
  const [optionChoices, setOptionChoices] = useState({});
  return [optionChoices, setOptionChoices];
};
//optionFilters
export const useTightSpreadPctEnabled = () => {
  const [tightSpreadPctEnabled, setTightSpreadPctEnabled] = useState(true);
  return [tightSpreadPctEnabled, setTightSpreadPctEnabled];
};

export const useTightSpreadCentsEnabled = () => {
  const [tightSpreadCentsEnabled, setTightSpreadCentsEnabled] = useState(false);
  return [tightSpreadCentsEnabled, setTightSpreadCentsEnabled];
};

export const useOptionPriceRangeEnabled = () => {
  const [optionPriceRangeEnabled, setOptionPriceRangeEnabled] = useState(false);
  return [optionPriceRangeEnabled, setOptionPriceRangeEnabled];
};

export const useQtyRangeEnabled = () => {
  const [qtyRangeEnabled, setQtyRangeEnabled] = useState(false);
  return [qtyRangeEnabled, setQtyRangeEnabled];
};

export const useDollarRangeEnabled = () => {
  const [dollarRangeEnabled, setDollarRangeEnabled] = useState(false);
  return [dollarRangeEnabled, setDollarRangeEnabled];
};

export const useQtyRange = () => {
  const [qtyRange, dispatchQtyRange] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      minQty: 0,
      maxQty: 0,
    }
  );
  return [qtyRange, dispatchQtyRange];
};

export const useDollarRange = () => {
  const [dollarRange, dispatchDollarRange] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      minDollar: 0,
      maxDollar: 0,
    }
  );
  return [dollarRange, dispatchDollarRange];
};

export const useTightSpreadPct = () => {
  const [tightSpreadPct, dispatchTightSpreadPct] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      maxOptionSpreadPct: 0.05,
    }
  );
  return [tightSpreadPct, dispatchTightSpreadPct];
};

export const useTightSpreadCents = () => {
  const [tightSpreadCents, dispatchTightSpreadCents] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      maxOptionSpreadCents: 0.0,
    }
  );
  return [tightSpreadCents, dispatchTightSpreadCents];
};

export const useOptionPriceRange = () => {
  const [optionPriceRange, dispatchOptionPriceRange] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      minPrice: 0,
      maxPrice: 0,
    }
  );
  return [optionPriceRange, dispatchOptionPriceRange];
};

//optionChainStrategy
export const useHugCurrentPrice = () => {
  const [hugCurrentPrice, dispatchHugCurrentPrice] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {
      numOfStrikes: 5,
    }
  );
  return [hugCurrentPrice, dispatchHugCurrentPrice];
};

export const useOtm1 = () => {
  const [otm1, dispatchOtm1] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {}
  );
  return [otm1, dispatchOtm1];
};

export const useItm1 = () => {
  const [itm1, dispatchItm1] = useReducer(
    (data, action) => ({ ...data, ...action }),
    {}
  );
  return [itm1, dispatchItm1];
};

export const useHugCurrentPriceEnabled = () => {
  const [hugCurrentPriceEnabled, setHugCurrentPriceEnabled] = useState(true);
  return [hugCurrentPriceEnabled, setHugCurrentPriceEnabled];
};

export const useOtm1Enabled = () => {
  const [otm1Enabled, setOtm1Enabled] = useState(false);
  return [otm1Enabled, setOtm1Enabled];
};

export const useItm1Enabled = () => {
  const [itm1Enabled, setItm1Enabled] = useState(false);
  return [itm1Enabled, setItm1Enabled];
};

export const useViewOptionManagementEnabled = () => {
  const [
    viewOptionManagementEnabled,
    setViewOptionManagementEnabled,
  ] = useState(false);
  return [viewOptionManagementEnabled, setViewOptionManagementEnabled];
};

export const useExpirationDates = () => {
  const [expirationDates, setExpirationDates] = useState([]);
  return [expirationDates, setExpirationDates];
};

export const useBuyOrSellOptions = () => {
  const [buyOrSellOption, setBuyOrSellOption] = useState("LONG");
  return [buyOrSellOption, setBuyOrSellOption];
};

export const useOTM = () => {
  const [otm, setOtm] = useState(false);
  return [otm, setOtm];
};
export const useITM = () => {
  const [itm, setItm] = useState(false);
  return [itm, setItm];
};
export const useNotExpiringToday = () => {
  const [notExpiringToday, setNotExpiringToday] = useState(false); //this is ONLY so frontend can use this. no need to pass to backend. will be set to undefined before sending
  return [notExpiringToday, setNotExpiringToday];
};

export function useOptionManagement(
  useHugCurPriceEnabled, //1
  useTSpreadPctEnabled, //2
  useTSpreadCentsEnabled, //3
  useOptionRangeEnabled, //4
  useQuantityRangeEnabled,
  useDlrRangeEnabled,
  hugCurPrice, //1
  tSpreadPct, //2
  tSpreadCents, //3
  OptionRange, //4
  quantityRange,
  dlrRange,
  //viewOptions
  expireDates,
  BoSOptions,
  Otm,
  Itm,
  notEToday,
  option_choices,
  OTM1Enabled,
  OTM1,
  ITM1Enabled,
  ITM1
) {
  const [
    hugCurrentPriceEnabled,
    setHugCurrentPriceEnabled,
  ] = useHugCurPriceEnabled;

  const [otm1Enabled, setOtm1Enabled] = OTM1Enabled;

  const [itm1Enabled, setItm1Enabled] = ITM1Enabled;

  const [
    tightSpreadPctEnabled,
    setTightSpreadPctEnabled,
  ] = useTSpreadPctEnabled;

  const [
    tightSpreadCentsEnabled,
    setTightSpreadCentsEnabled,
  ] = useTSpreadCentsEnabled;

  const [
    optionPriceRangeEnabled,
    setOptionPriceRangeEnabled,
  ] = useOptionRangeEnabled;

  const [qtyRangeEnabled, setQtyRangeEnabled] = useQuantityRangeEnabled;

  const [dollarRangeEnabled, setDollarRangeEnabled] = useDlrRangeEnabled;

  const [hugCurrentPrice, dispatchHugCurrentPrice] = hugCurPrice;
  const [tightSpreadPct, dispatchTightSpreadPct] = tSpreadPct;
  const [tightSpreadCents, dispatchTightSpreadCents] = tSpreadCents;
  const [optionPriceRange, dispatchOptionPriceRange] = OptionRange;

  const [qtyRange, dispatchQtyRange] = quantityRange;
  const [dollarRange, dispatchDollarRange] = dlrRange;
  const [expirationDates, setExpirationDates] = expireDates;
  const [buyOrSellOption, setBuyOrSellOption] = BoSOptions;
  const [otm, setOtm] = Otm;
  const [itm, setItm] = Itm;
  const [optionChoices, setOptionChoices] = option_choices;

  const [notExpiringToday, setNotExpiringToday] = notEToday;

  const [otm1, dispatchOtm1] = OTM1;

  const [itm1, dispatchItm1] = ITM1;

  const OptionChainStrategyProcessor = useMemo(
    () => ({
      hugCurrentPrice: {
        numOfStrikes: parseFloat(hugCurrentPrice.numOfStrikes),
      },
      OTM1: {},
      ITM1: {},
    }),
    [hugCurrentPrice, otm1, itm1]
  );

  const OptionFiltersProcessor = useMemo(
    () => ({
      optionPriceRange: {
        minPrice: parseFloat(optionPriceRange.minPrice),
        maxPrice: parseFloat(optionPriceRange.maxPrice),
      },
      tightSpreadPct: {
        maxOptionSpreadPct: parseFloat(tightSpreadPct.maxOptionSpreadPct),
      },
      tightSpreadCents: {
        maxOptionSpreadCents: parseFloat(tightSpreadCents.maxOptionSpreadCents),
      },
      qtyRange: {
        minQty: parseFloat(qtyRange.minQty),
        maxQty: parseFloat(qtyRange.maxQty),
      },
      dollarRange: {
        minDollar: parseFloat(dollarRange.minDollar),
        maxDollar: parseFloat(dollarRange.maxDollar),
      },
    }),
    [optionPriceRange, tightSpreadPct, tightSpreadCents, qtyRange, dollarRange]
  );

  const optionsManagement = useMemo(
    () => ({
      optionChoices: optionChoices,
      expirationDates: expirationDates,
      buyOrSellOption: buyOrSellOption,
      OTM: otm,
      ITM: itm,
      notExpiringToday: notExpiringToday,
      optionChainStrategy: {
        ...(hugCurrentPriceEnabled && {
          hugCurrentPrice: OptionChainStrategyProcessor.hugCurrentPrice,
        }),
        ...(otm1Enabled && {
          OTM1: OptionChainStrategyProcessor.OTM1,
        }),
        ...(itm1Enabled && {
          ITM1: OptionChainStrategyProcessor.ITM1,
        }),
      },
      optionFilters: {
        ...(tightSpreadPctEnabled && {
          tightSpreadPct: OptionFiltersProcessor.tightSpreadPct,
        }),
        ...(tightSpreadCentsEnabled && {
          tightSpreadCents: OptionFiltersProcessor.tightSpreadCents,
        }),
        ...(optionPriceRangeEnabled && {
          optionPriceRange: OptionFiltersProcessor.optionPriceRange,
        }),
        ...(qtyRangeEnabled && {
          qtyRange: OptionFiltersProcessor.qtyRange,
        }),
        ...(dollarRangeEnabled && {
          dollarRange: OptionFiltersProcessor.dollarRange,
        }),
      },
    }),
    [
      optionChoices,
      otm,
      itm,
      expirationDates,
      buyOrSellOption,
      OptionChainStrategyProcessor,
      OptionFiltersProcessor,
      tightSpreadPctEnabled,
      tightSpreadCentsEnabled,
      hugCurrentPriceEnabled,
      optionPriceRangeEnabled,
      qtyRangeEnabled,
      dollarRangeEnabled,
      notExpiringToday,
    ]
  );
  return optionsManagement;
}
